export type DisplayStatus =
  | 'not_submitted'
  | 'pending'
  | 'approved'
  | 'needs_attention'
  | 'past_due'
  | 'past_due_grace'
  | 'in_review';

/** Map backend submission_status.state (snake_case) to dashboard display status */
export function submissionStateToDisplayStatus(state: string): DisplayStatus {
  const s = state.toLowerCase();
  if (s === 'approved') return 'approved';
  if (s === 'pending_review') return 'pending';
  if (s === 'in_review') return 'in_review';
  if (s === 'rejected' || s === 'needs_revision' || s === 'needs_attention') return 'needs_attention';
  if (s === 'past_due') return 'past_due';
  if (s === 'not_submitted' || s === 'draft') return 'not_submitted';
  return 'not_submitted';
}

export const getStatusColor = (status: DisplayStatus): string => {
  const colors: Record<DisplayStatus, string> = {
    not_submitted: 'gray',
    pending: 'yellow',
    approved: 'green',
    needs_attention: 'red',
    past_due: 'red',
    past_due_grace: 'yellow',
    in_review: 'yellow'
  };
  return colors[status];
};

export const getStatusLabel = (status: DisplayStatus): string => {
  const labels: Record<DisplayStatus, string> = {
    not_submitted: 'Not Submitted',
    pending: 'Pending Review',
    approved: 'Approved',
    needs_attention: 'Needs Attention',
    past_due: 'Past Due',
    past_due_grace: 'Past Due',
    in_review: 'In Review'
  };
  return labels[status];
};

/** Display label for a stored `submission_status.state` token (admin filters, API-driven options). */
export function submissionStateTokenToLabel(state: string): string {
  const s = state.toLowerCase();
  const direct: Record<string, string> = {
    approved: 'Approved',
    pending_review: 'Pending Review',
    not_submitted: 'Not Submitted',
    draft: 'Draft',
    rejected: 'Rejected',
    needs_revision: 'Needs Revision',
    needs_attention: 'Needs Attention',
    past_due: 'Past Due',
    in_review: 'In Review'
  };
  if (direct[s]) return direct[s];
  return s
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
} 